import { render, staticRenderFns } from "./AppUpdateNotice.vue?vue&type=template&id=aa41e84c&"
import script from "./AppUpdateNotice.vue?vue&type=script&lang=js&"
export * from "./AppUpdateNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports